import { Hero } from '../components/landing/Hero';
import { Features } from '../components/landing/Features';
import { PainPoints } from '../components/landing/PainPoints';
import { Pricing } from '../components/landing/Pricing';
import { FAQ } from '../components/landing/FAQ';
import { ContactSection } from '../components/landing/ContactSection';
import { CTABanner } from '../components/marketing/CTABanner';
import { JourneyOverview } from '../components/marketing/JourneyOverview';
import { SEO } from '../components/SEO';
import { JsonLd, ORGANIZATION_SCHEMA, WEBSITE_SCHEMA, FAQ_SCHEMA } from '../components/JsonLd';

export function HomePage(): JSX.Element {
  return (
    <>
      <SEO />
      <JsonLd data={ORGANIZATION_SCHEMA} />
      <JsonLd data={WEBSITE_SCHEMA} />
      <JsonLd data={FAQ_SCHEMA} />
      <Hero />
      <PainPoints />
      <Features />
      <JourneyOverview />
      <Pricing />
      <FAQ />
      <ContactSection />
      <CTABanner />
    </>
  );
}
